export type SnapshotDay = "today" | "yesterday";

export type SnapshotSlotKey = "00_05" | "05_12" | "12_19" | "19_24";

export type SnapshotTimestampItem = {
  snapshot_timestamp: string | null;
};

export type SnapshotTimestampsResponse = Record<
  SnapshotSlotKey,
  SnapshotTimestampItem
>;

export type SnapshotSlotDefinition = {
  key: SnapshotSlotKey;
  label: string;
};

export const SNAPSHOT_SLOT_DEFINITIONS: SnapshotSlotDefinition[] = [
  { key: "00_05", label: "0:00 - 5:00" },
  { key: "05_12", label: "5:00 - 12:00" },
  { key: "12_19", label: "12:00 - 19:00" },
  { key: "19_24", label: "19:00 - 0:00" },
];

export const SNAPSHOT_DAY_LABELS: Record<SnapshotDay, string> = {
  today: "Сегодня",
  yesterday: "Вчера",
};
